import { Grid } from "@mui/material";
import React from "react";
import TransferOrderHeader from "./home/header";
import TransferOrderTable from "./home/table";

const TransferOrders = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TransferOrderHeader />
      </Grid>
      <Grid item xs={12}>
        <TransferOrderTable />
      </Grid>
    </Grid>
  );
};

export default TransferOrders;
